import { styled } from "@mui/material/styles";
import { ListItemButton, Box, Typography } from "@mui/material";
import { ListItemButtonProps } from "@mui/material/ListItemButton";

export interface StyledMenuItemButtonProps extends ListItemButtonProps {
  active?: boolean;
  depth?: number;
  component?: React.ElementType;
  to?: string;
}

export const StyledMenuItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => !["active", "depth"].includes(prop.toString()),
})<StyledMenuItemButtonProps>(({ theme, active, depth = 0 }) => ({
  paddingLeft: theme.spacing(1 + depth * 2),
  paddingRight: theme.spacing(1),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  marginBottom: theme.spacing(0.5),
  height: "48px",
  gap: theme.spacing(1.5),
  ...(active && {
    backgroundColor: theme.palette.menu.dark,
    color: theme.palette.menu.light2,
    "& .MuiListItemIcon-root": {
      color: theme.palette.menu.light2,
    },
  }),
}));

export const StyledHeaderBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const StyledUserInfoBox = styled(Box)(({ theme }) => ({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(1, 0),
  borderWidth: "1px 0px",
  borderStyle: "solid",
  borderColor: theme.palette.accent.main,
}));

export const StyledMenuContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: "auto",
  marginTop: theme.spacing(2),
}));

export const StyledFooterBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(2, 0),
  margin: "0 auto",
}));

export const StyledVersionText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "clickable",
})<{ clickable?: boolean }>(({ theme, clickable }) => ({
  cursor: clickable ? "pointer" : "default",
  ...(clickable && {
    "&:hover": {
      color: theme.palette.textMain.light,
      textDecoration: "underline",
    },
  }),
}));
